import React from 'react';

export const LogoMercadoPago = ({
  width,
  src = 'https://dk0k1i3js6c49.cloudfront.net/panel/medios_pago/mercadopago-card-img.png',
}) => {
  return <img width={width} src={src}></img>;
};
